/**
 * SoleadLab 2.0 - Progress Overlay
 *
 * Floating progress bar shown during Save to Server / Open from Server.
 * Reads from uiStore.progressOverlay.
 */

import { useUIStore } from '../../stores/uiStore';
import './ProgressOverlay.css';

export default function ProgressOverlay() {
  const overlay = useUIStore((s) => s.progressOverlay);
  if (!overlay?.visible) return null;

  const pct = overlay.total > 0
    ? Math.round((overlay.current / overlay.total) * 100)
    : 0;

  return (
    <div className="progress-overlay">
      <div className="progress-overlay__card">
        <div className="progress-overlay__label">{overlay.label}</div>
        <div className="progress-overlay__track">
          <div
            className="progress-overlay__fill"
            style={{ width: `${pct}%` }}
          />
        </div>
        {overlay.total > 0 && (
          <div className="progress-overlay__pct">{pct}%</div>
        )}
      </div>
    </div>
  );
}
